<template>
  <div class="report_form">
    <div class="header_title">
      <span>{{ data.userInfo.cname }}</span>
    </div>
    <!-- <el-row
      class="data_list"
      :class="{ mobile: isMobileObj.any }"
      :gutter="20"
      v-for="(list, index) in data.countList"
      :key="index"
    >
      <el-col
        :span="isMobileObj.any ? 12 : 4"
        v-for="(item, index2) in list"
        :key="index2"
      >
        <el-space class="item" direction="vertical" alignment="flex-start" fill>
          <div class="text">
            <img
              :src="
                require(`@/assets/img/index_icon${
                  ((index2 + index * 6) % 4) + 1
                }.svg`)
              "
            />
            {{ item.name }}（{{ item.unit }}）
          </div>
          <div class="number">
            {{ item.count }}
          </div>
          <div class="line"></div>
        </el-space>
      </el-col>
    </el-row> -->

    <div class="avatar_box box mb20" :class="{ mobile: isMobileObj.any }">
      <div class="l">
        <img
          v-if="countReactive.active.id"
          :src="countReactive.active.avatar"
        />
        <img v-else src="@/assets/img/avatar.png" />
        <el-popover popper-class="pd0" trigger="click" :width="226">
          <template #reference>
            <div class="info">
              <div>
                <el-space class="t1">
                  <div v-if="countReactive.active.id">
                    {{ countReactive.active.nickname }}
                  </div>
                  <div v-else>{{ data.userInfo.cname }}</div>
                  <img
                    class="select_arrow"
                    src="@/assets/img/select_arrow.png"
                  />
                </el-space>
              </div>
              <div class="t2">
                已绑定
                <el-icon v-if="data.loading" class="is-loading">
                  <Loading />
                </el-icon>
                <template v-else>{{ data.count_list.count1 }}</template>
                个账号
              </div>
            </div>
          </template>
          <template #default>
            <div
              class="select_item"
              :class="{ active: !countReactive.active.id }"
              @click="countReactive.active = {}"
            >
              <img src="@/assets/img/avatar.png" />
              <div class="ellipsis">全部账号</div>
            </div>
            <div
              class="select_item"
              :class="{ active: countReactive.active.id === item.id }"
              v-for="item in data.auth_list"
              :key="item.id"
              @click="countReactive.active = item"
            >
              <img :src="item.avatar" />
              <div class="ellipsis">{{ item.nickname }}</div>
            </div>
          </template>
        </el-popover>
      </div>
      <div class="r">
        <div class="item">
          <div class="t1">当前已绑定/可绑定账号</div>
          <div class="t2">
            <el-icon v-if="data.loading" class="is-loading">
              <Loading />
            </el-icon>
            <template v-else>{{ data.count_list.count1 }}</template>
            <!-- /{{
              data.userInfo.douyin_max_count +
              data.userInfo.douyin_enterprise_max_count +
              data.userInfo.kuaishou_max_count +
              data.userInfo.shipinhao_max_count +
              data.userInfo.xiaohongshu_max_count +
              data.userInfo.bilibili_max_count
            }} -->
            /{{
              data.userInfo.douyin_max_count +
              data.userInfo.douyin_employee_max_count +
              data.userInfo.douyin_enterprise_max_count +
              data.userInfo.kuaishou_max_count +
              data.userInfo.shipinhao_max_count +
              data.userInfo.xiaohongshu_max_count +
              data.userInfo.bilibili_max_count +
              data.userInfo.toutiao_max_count +
              data.userInfo.haokan_max_count
            }}
          </div>
        </div>
        <div class="item">
          <div class="t1">今日已发布/每日发布上限</div>
          <div class="t2">
            <el-icon v-if="data.loading" class="is-loading">
              <Loading />
            </el-icon>
            <template v-else>{{ data.count_list.count2 }}</template>
            <!-- /{{ data.userInfo.daily_release_max_count }} -->
            /{{
              data.userInfo.video_daily_release_count +
              data.userInfo.image_daily_release_count
            }}
          </div>
        </div>
        <div class="item">
          <div class="t1">已剪辑数量/总剪辑数量</div>
          <div class="t2">
            <el-icon v-if="data.loading" class="is-loading">
              <Loading />
            </el-icon>
            <template v-else>{{ data.count_list.count3 }}</template>
            /{{ data.userInfo.video_task_max_count }}
          </div>
        </div>
      </div>
    </div>
    <div class="count_box mb20" :class="{ mobile: isMobileObj.any }">
      <div class="item box">
        <img src="@/assets/img/index_count_icon1.png" />
        <div>
          <div class="t1">粉丝量</div>
          <div class="t2">{{ countReactive.data.fans_count }}</div>
        </div>
      </div>
      <div class="item box">
        <img src="@/assets/img/index_count_icon2.png" />
        <div>
          <div class="t1">视频量</div>
          <div class="t2">{{ countReactive.data.video_count }}</div>
        </div>
      </div>
      <div class="item box">
        <img src="@/assets/img/index_count_icon3.png" />
        <div>
          <div class="t1">曝光量</div>
          <div class="t2">{{ countReactive.data.play_count }}</div>
        </div>
      </div>
      <div class="item box">
        <img src="@/assets/img/index_count_icon4.png" />
        <div>
          <div class="t1">点赞量</div>
          <div class="t2">{{ countReactive.data.digg_count }}</div>
        </div>
      </div>
      <div class="item box">
        <img src="@/assets/img/index_count_icon5.png" />
        <div>
          <div class="t1">评论量</div>
          <div class="t2">{{ countReactive.data.comment_count }}</div>
        </div>
      </div>
      <div class="item box">
        <img src="@/assets/img/index_count_icon6.png" />
        <div>
          <div class="t1">私信量</div>
          <div class="t2">
            {{ countReactive.data.user_intention_dialogue_count }}
          </div>
        </div>
      </div>
    </div>
    <el-row :gutter="20" class="tbox" v-if="responseFields2.tableData.length">
      <el-col
        class="box_1440_1"
        :span="isMobileObj.any ? 24 : 10"
        :style="{ marginBottom: isMobileObj.any ? '20px' : 0 }"
      >
        <div class="box pt15">
          <div class="title mb0">流量来源</div>
          <div class="doughnut_box">
            <ChartDoughnut
              :chartData="data.chartDataDoughnut"
              style="width: 100%; height: 229px"
            />
          </div>
        </div>
      </el-col>
      <el-col class="box_1440_2" :span="isMobileObj.any ? 24 : 6">
        <div class="box">
          <div class="title">
            关键词数据
            <span v-if="data.keyword_time">
              （{{ moment(data.keyword_time).format('YYYY-MM-DD') }}）
            </span>
          </div>
          <ul class="keyword_list">
            <li v-for="(itme, index) in data.keyword_list" :key="index">
              <p>{{ itme.name }}</p>
              <span>{{ itme.count.toLocaleString() }}</span>
            </li>
          </ul>
        </div>
      </el-col>
      <el-col class="box_1440_3" :span="isMobileObj.any ? 24 : 8">
        <div class="box">
          <div class="title title2 mb10">
            <img src="@/assets/img/index_icon2.svg" />
            套餐到期时间
          </div>
          <div class="package_box">
            <ul>
              <li>
                <span>开通</span>
                <strong>
                  {{ moment(data.userInfo.start_time).format('YYYY-MM-DD') }}
                </strong>
              </li>
              <li>
                <span>到期</span>
                <strong>
                  {{ moment(data.userInfo.end_time).format('YYYY-MM-DD') }}
                </strong>
              </li>
              <li>
                <span>已用</span>
                <strong style="color: #ffad3a">
                  {{ use_days }}
                </strong>
                <span class="ml5">天</span>
              </li>
            </ul>
            <div class="dashboard">
              <div class="ring">
                <i
                  class="scale"
                  v-for="i in 37"
                  :key="i"
                  :style="`transform: rotate(${225 + (i - 1) * 7.5}deg)`"
                ></i>
                <i
                  class="pointer"
                  :style="`transform: rotate(${pointer_rotate}deg)`"
                ></i>
              </div>
              <div class="info">{{ use_days }}天</div>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>

    <el-row :gutter="20" class="tbox2" v-if="responseFields1.tableData.length">
      <el-col
        :span="24"
        :style="{ marginBottom: isMobileObj.any ? '20px' : 0 }"
      >
        <div class="box pt15">
          <div class="title mb20">意向用户</div>
          <el-table
            ref="table"
            :data="responseFields1.tableData"
            highlight-current-row
            style="width: 100%"
            :header-cell-style="{ textAlign: 'center' }"
            :cell-style="{ textAlign: 'center' }"
          >
            <el-table-column
              v-if="!isMobileObj.any"
              type="index"
              label="序号"
              width="48"
            />
            <el-table-column
              v-if="!isMobileObj.any"
              prop="from_avatar"
              label="头像"
            >
              <template #default="scope">
                <img
                  :src="scope.row.from_avatar"
                  height="40"
                  style="border-radius: 20px"
                />
              </template>
            </el-table-column>
            <el-table-column prop="from_nick_name" label="昵称" />
            <el-table-column prop="event_enum" label="互动类型" />
            <el-table-column
              v-if="!isMobileObj.any"
              prop="tel"
              label="联系电话"
            />
            <el-table-column prop="create_time_format" label="线索时间" />
          </el-table>
          <div class="scroll_box" v-if="responseFields1.tableData.length">
            <el-table
              ref="table"
              :data="responseFields1.tableData"
              highlight-current-row
              style="width: 100%"
              :header-cell-style="{ textAlign: 'center' }"
              :cell-style="{ textAlign: 'center' }"
              :show-header="false"
              :style="{
                animationDuration: `${responseFields1.tableData.length}s`,
              }"
            >
              <el-table-column
                v-if="!isMobileObj.any"
                type="index"
                label="序号"
                width="48"
              />
              <el-table-column
                v-if="!isMobileObj.any"
                prop="from_avatar"
                label="头像"
              >
                <template #default="scope">
                  <img
                    :src="scope.row.from_avatar"
                    height="40"
                    style="border-radius: 20px"
                  />
                </template>
              </el-table-column>
              <el-table-column prop="from_nick_name" label="昵称" />
              <el-table-column prop="event_enum" label="互动类型" />
              <el-table-column
                v-if="!isMobileObj.any"
                prop="tel"
                label="联系电话"
              />
              <el-table-column prop="create_time_format" label="线索时间" />
            </el-table>
          </div>
          <el-space
            v-else
            class="pt50 pb50"
            direction="vertical"
            style="width: 100%"
          >
            <img src="@/assets/img/report_form_user_intention_list_empty.png" />
            <div>暂无意向用户，您可以通过发布视频增加流量</div>
          </el-space>
        </div>
      </el-col>
      <!-- <el-col :span="isMobileObj.any ? 24 : 12">
        <div class="box pt15">
          <div class="title mb20">互动线索</div>
          <el-table
            ref="table"
            :data="data.tableData2"
            highlight-current-row
            style="width: 100%"
            :header-cell-style="{ textAlign: 'center' }"
            :cell-style="{ textAlign: 'center' }"
          >
            <el-table-column type="index" label="序号" width="48" />
            <el-table-column prop="nickname" label="昵称" />
            <el-table-column prop="telephone" label="联系方式" />
            <el-table-column
              prop="update_time"
              label="查询时间"
              min-width="88"
            />
          </el-table>
          <div class="scroll_box" v-if="data.tableData2.length">
            <el-table
              ref="table"
              :data="data.tableData2"
              highlight-current-row
              style="width: 100%"
              :header-cell-style="{ textAlign: 'center' }"
              :cell-style="{ textAlign: 'center' }"
              :show-header="false"
              :style="{
                animationDuration: `${data.tableData2.length}s`,
              }"
            >
              <el-table-column type="index" label="序号" width="48" />
              <el-table-column prop="nickname" label="昵称" />
              <el-table-column prop="telephone" label="联系方式" />
              <el-table-column
                prop="update_time"
                label="查询时间"
                min-width="88"
              />
            </el-table>
          </div>
        </div>
      </el-col> -->
    </el-row>

    <div class="box pt15 mb20" v-if="responseFields3.total">
      <div class="title mb20">
        按天计费报表
        <span>（累计达标{{ responseFields3.total }}次）</span>
      </div>
      <el-space
        class="mb20"
        direction="vertical"
        fill
        :size="16"
        style="width: 100%"
        prefix-cls="space"
        v-loading="loading"
      >
        <el-table
          ref="table"
          :data="responseFields3.tableData"
          highlight-current-row
          style="width: 100%"
          :header-cell-style="{ textAlign: 'center' }"
          :cell-style="{ textAlign: 'center' }"
        >
          <el-table-column
            v-if="!isMobileObj.any"
            type="index"
            label="序号"
            width="48"
          />
          <el-table-column prop="keyword" label="关键词" />
          <el-table-column prop="rank" label="排名" width="50" />
          <el-table-column
            v-if="!isMobileObj.any"
            prop="name"
            label="蓝v账号"
          />
          <el-table-column
            prop="create_time_format"
            label="检测时间"
            width="96"
          />
          <template #empty>
            <el-space class="pt50 pb50" direction="vertical">
              <img src="@/assets/img/report_form_empty.png" />
              <div>暂无关键词，您可以通过发布视频增加流量</div>
            </el-space>
          </template>
        </el-table>
        <el-row>
          <el-pagination
            :class="{ mobile: isMobileObj.any }"
            small
            background
            layout="prev, pager, next, sizes"
            :total="responseFields3.total"
            v-model:currentPage="requestFields3.page"
            v-model:page-size="requestFields3.limit"
            :page-sizes="[10, 20, 50, 100]"
          />
        </el-row>
      </el-space>
    </div>

    <div class="box pt15 mb20" v-if="responseFields2.tableData.length">
      <div class="title mb20">
        关键词排名
        <span>（共有{{ responseFields2.total }}个排名）</span>
      </div>
      <el-space
        class="mb20"
        direction="vertical"
        fill
        :size="16"
        style="width: 100%"
        prefix-cls="space"
        v-loading="loading"
      >
        <el-table
          ref="table"
          :data="responseFields2.tableData"
          highlight-current-row
          style="width: 100%"
          :header-cell-style="{ textAlign: 'center' }"
          :cell-style="{ textAlign: 'center' }"
        >
          <el-table-column
            v-if="!isMobileObj.any"
            type="index"
            label="序号"
            width="48"
          />
          <el-table-column prop="keyword" label="关键词" />
          <el-table-column prop="rank" label="排名" width="50" />
          <el-table-column v-if="!isMobileObj.any" label="所属账号">
            {{ data.userInfo.cname }}
          </el-table-column>
          <el-table-column
            prop="update_time_format"
            label="查询时间"
            width="96"
          />
          <template #empty>
            <el-space class="pt50 pb50" direction="vertical">
              <img src="@/assets/img/report_form_empty.png" />
              <div>暂无关键词，您可以通过发布视频增加流量</div>
            </el-space>
          </template>
        </el-table>
        <el-row>
          <el-pagination
            :class="{ mobile: isMobileObj.any }"
            small
            background
            layout="prev, pager, next, sizes"
            :total="responseFields2.total"
            v-model:currentPage="requestFields2.page"
            v-model:page-size="requestFields2.limit"
            :page-sizes="[10, 20, 50, 100]"
          />
        </el-row>
      </el-space>
    </div>

    <!-- <el-row>
      <el-col :span="24">
        <div class="box">
          <div class="title">数据统计</div>
          <ChartLine :chartData="data.chartDataLine" />
        </div>
      </el-col>
    </el-row>
    <canvas ref="canvasRef" style="display: none"></canvas> -->
  </div>
</template>

<script setup>
import { reactive, ref, computed, watchEffect, toRefs } from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'
import moment from 'moment'
import isMobile from 'ismobilejs'
import {
  report_form,
  report_form_count,
  report_form_user_intention_list,
  report_form_douyin_keywords_rank_data,
  report_form_douyin_rank_task_data,
} from '@/utils/api'
import ChartDoughnut from '@/components/ChartDoughnut2'
// import ChartLine from '@/components/ChartLine'
import { Loading } from '@element-plus/icons-vue'

const route = useRoute()

const store = useStore()
const { state } = store
const { loading } = toRefs(state)

const isMobileObj = isMobile(window.navigator)

const data = reactive({
  userInfo: {},
  // countList: [
  //   [
  //     { name: '总曝光量', unit: '次', count: 0 },
  //     { name: '自然流量', unit: '次', count: 0 },
  //     { name: '商业流量', unit: '次', count: 0 },
  //     { name: '用户行为', unit: '次', count: 0 },
  //     { name: '私信跟进', unit: '次', count: 0 },
  //     { name: '意向用户', unit: '个', count: 0 },
  //   ],
  //   [
  //     { name: '获赞次数', unit: '个', count: 0 },
  //     { name: '累计粉丝', unit: '个', count: 0 },
  //     { name: '互动线索', unit: '个', count: 0 },
  //     { name: '私信数量', unit: '个', count: 0 },
  //     { name: '评论数量', unit: '个', count: 0 },
  //     { name: '大数据线索', unit: '个', count: 0 },
  //   ],
  // ],
  keyword_list: [
    { name: 'TOP10关键词', count: 0 },
    { name: 'TOP20关键词', count: 0 },
    { name: '八字以下关键词', count: 0 },
    { name: 'A+B & B+C关键词', count: 0 },
    { name: '词库关键词', count: 0 },
  ],
  keyword_time: '',
  chartDataDoughnut: {
    // labels: ['VueJs', 'EmberJs', 'ReactJs', 'AngularJs'],
    // datasets: [
    //   {
    //     backgroundColor: ['#41B883', '#E46651', '#00D8FF', '#DD1B16'],
    //     data: [40, 20, 80, 10],
    //   },
    // ],
  },
  chartDataLine: {
    // labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
    // datasets: [
    //   {
    //     label: 'Data One',
    //     backgroundColor: '#00D8FF',
    //     fill: true,
    //     tension: 0.4,
    //     data: [40, 39, 10, 40, 39, 80, 40],
    //   },
    //   {
    //     label: 'Data Two',
    //     backgroundColor: '#E46651',
    //     fill: true,
    //     tension: 0.4,
    //     data: [60, 55, 32, 10, 2, 12, 53],
    //   },
    // ],
  },
  tableData1: [],
  tableData2: [],
  count_list: {
    count1: 0,
    count2: 0,
    count3: 0,
  },
  loading: true,
})

report_form({ page: 1, limit: 100, ...route.params }).then(({ data: res }) => {
  // res.data.count_list.forEach((v, i) => {
  //   let floor = Math.floor(i / 6)
  //   let modulo = i % 6
  //   data.countList[floor][modulo] = v
  // })

  data.chartDataDoughnut = {
    labels: ['自然流量', '商业流量'],
    datasets: [
      {
        backgroundColor: ['#0E2E5B'],
        borderWidth: 0,
        data: [1],
        weight: 2,
      },
      {
        backgroundColor: ['#016FED', '#EDA600'],
        data: res.data.percent_count,
        borderWidth: 0,
        weight: 10,
      },
    ],
  }

  // let gradient1 = canvasRef.value
  //   .getContext('2d')
  //   .createLinearGradient(0, 0, 0, 450)
  // let gradient2 = canvasRef.value
  //   .getContext('2d')
  //   .createLinearGradient(0, 0, 0, 450)

  // gradient1.addColorStop(0, 'rgba(1, 111, 237, 0.2)')
  // gradient1.addColorStop(1, 'rgba(1, 111, 237, 0)')
  // gradient2.addColorStop(0, 'rgba(237,166,0, 0.2)')
  // gradient2.addColorStop(1, 'rgba(237,166,0, 0)')

  // res.data.datasets[0].backgroundColor = gradient1
  // res.data.datasets[1].backgroundColor = gradient2

  // // data.chartDataLine = res.data
  // data.chartDataLine = {
  //   labels: res.data.labels,
  //   datasets: [
  //     {
  //       label: '点击',
  //       borderWidth: 3,
  //       borderColor: '#016FED',
  //       backgroundColor: gradient1,
  //       fill: true,
  //       tension: 0,
  //       data: res.data.datasets[0],
  //     },
  //     {
  //       label: '展现',
  //       borderWidth: 3,
  //       borderColor: '#EDA600',
  //       backgroundColor: gradient2,
  //       fill: true,
  //       tension: 0,
  //       data: res.data.datasets[1],
  //     },
  //   ],
  // }

  // res.data.tableData1.push(...res.data.tableData1)
  // res.data.tableData2.push(...res.data.tableData2)

  Object.assign(data, res.data)
  document.title = `${res.data.userInfo.cname}数据报表`
  data.loading = false
})

const canvasRef = ref()

const use_days = computed(() => {
  return Math.round(
    moment.duration(moment().diff(moment(data.userInfo.start_time))).asDays()
  )
})

const pointer_rotate = ref(225)
watchEffect(
  () => {
    pointer_rotate.value =
      225 + ((use_days.value > 360 ? 360 : use_days.value) / 10) * 7.5
  },
  {
    flush: 'post',
  }
)

const countReactive = reactive({
  active: {},
  data: {
    fans_count: 0,
    video_count: 0,
    play_count: 0,
    digg_count: 0,
    comment_count: 0,
    user_intention_dialogue_count: 0,
  },
})

watchEffect((onInvalidate) => {
  const controller = new AbortController()
  report_form_count(
    { aid: countReactive.active.id, ...route.params },
    { signal: controller.signal }
  ).then(({ data: res }) => {
    countReactive.data = res.data
  })
  onInvalidate(() => {
    controller.abort()
  })
})

const requestFields1 = reactive({
  page: 1,
  limit: 100,
})
const responseFields1 = reactive({
  tableData: [],
  total: 0,
})

watchEffect((onInvalidate) => {
  const controller = new AbortController()
  report_form_user_intention_list(
    { ...requestFields1, ...route.params },
    { signal: controller.signal }
  ).then(({ data: res }) => {
    while (res.data.length > 0 && res.data.length < 10) {
      res.data.push(...res.data)
    }
    responseFields1.tableData = res.data
    responseFields1.total = res.count ?? 10
  })
  onInvalidate(() => {
    controller.abort()
  })
})

const requestFields2 = reactive({
  page: 1,
  limit: 100,
})
const responseFields2 = reactive({
  tableData: [],
  total: 0,
})

watchEffect((onInvalidate) => {
  const controller = new AbortController()
  report_form_douyin_keywords_rank_data(
    { ...requestFields2, ...route.params },
    { signal: controller.signal }
  ).then(({ data: res }) => {
    responseFields2.tableData = res.data
    responseFields2.total = res.count ?? 10
  })
  onInvalidate(() => {
    controller.abort()
  })
})

const requestFields3 = reactive({
  page: 1,
  limit: 100,
})
const responseFields3 = reactive({
  tableData: [],
  total: 0,
})

watchEffect((onInvalidate) => {
  const controller = new AbortController()
  report_form_douyin_rank_task_data(
    { ...requestFields3, ...route.params },
    { signal: controller.signal }
  ).then(({ data: res }) => {
    responseFields3.tableData = res.data
    responseFields3.total = res.count ?? 10
  })
  onInvalidate(() => {
    controller.abort()
  })
})
</script>

<style scoped lang="scss">
@import '@/assets/css/color.scss';

.el-row {
  margin-bottom: 20px;
}
.tbox {
  .box {
    height: 303px;
  }
}
.doughnut_box {
  display: flex;
  align-items: center;
  width: 80%;
  margin-left: 20%;
  canvas::after {
    content: '';
    width: 229px;
    height: 229px;
    border-radius: 50%;
    background-color: #0e2e5b;
    position: absolute;
    z-index: -1;
  }
}
.keyword_list {
  font-size: 16px;
  li {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #24385e;
    height: 38px;
    &:last-child {
      border-bottom: 0;
    }
    p {
      color: #cadbee;
    }
  }
}

.package_box {
  height: calc(100% - 61px);
  display: flex;
  align-items: center;
  justify-content: space-between;
  ul {
    padding-top: 25px;
    padding-left: 20px;
  }
  li {
    display: flex;
    align-items: center;
    font-size: 18px;
    margin-bottom: 25px;
    white-space: nowrap;
    span {
      color: #cadbee;
      margin-right: 13px;
    }
  }
  .dashboard {
    flex: none;
    width: 208px;
    height: 208px;
    border-radius: 50%;
    background-color: #0b1830;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    .ring {
      flex: none;
      width: 188px;
      height: 188px;
      border-radius: 50%;
      border-width: 30px;
      border-style: solid;
      border-color: #0cb876 #ed8e00 #0b1830 #016fed;
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      .scale {
        width: 1px;
        height: 94px;
        border-top: 7px solid #fff;
        position: absolute;
        top: -30px;
        transform: rotate(225deg);
        transform-origin: bottom center;
        z-index: 1;
      }
      .pointer {
        width: 10px;
        height: 94px;
        background: url(@/assets/img/dashboard_pointer.png) no-repeat bottom
          center;
        position: absolute;
        margin-left: -5px;
        top: -30px;
        transform-origin: bottom center;
        transform: rotate(225deg);
        transition: transform 1s;
        z-index: 2;
      }
    }
    .info {
      position: absolute;
      top: 115px;
      font-size: 25px;
      font-weight: bold;
      z-index: 3;
      span {
        color: #cadbee;
      }
    }
  }
}
.report_form {
  padding: 20px 34px 34px;
  .header_title {
    font-size: 28px;
    text-align: center;
    font-weight: bold;
    margin-bottom: 40px;
    margin-left: -20px;
    margin-right: -20px;
    overflow: hidden;
    span {
      display: inline-block;
      position: relative;
      &::before,
      &::after {
        content: '';
        width: 154px;
        height: 4px;
        position: absolute;
        top: 50%;
        background-repeat: no-repeat;
      }
      &::before {
        background-image: url(@/assets/img/title_l.png);
        right: 100%;
        margin-right: 43px;
      }
      &::after {
        background-image: url(@/assets/img/title_r.png);
        left: 100%;
        margin-left: 47px;
      }
    }
  }
  :deep(.el-table) .cell {
    line-height: 38px;
    white-space: nowrap;
    padding: 0 5px;
  }
}
.tbox2 {
  :deep(.el-table__body-wrapper) {
    display: none;
  }
  .scroll_box {
    /* height: 660px; */
    height: 572px;
    position: relative;
    overflow: hidden;
    :deep(.el-table__body-wrapper) {
      display: block;
    }
    .el-table {
      animation: infinite_scroll 10s linear infinite;
    }
  }
}

@media screen and (max-width: 1440px) {
  .box_1440_1 {
    max-width: 30%;
    flex: 0 0 30%;
    .doughnut_box {
      margin-left: 10%;
    }
  }
  .box_1440_2 {
    max-width: 30%;
    flex: 0 0 30%;
  }
  .box_1440_3 {
    max-width: 40%;
    flex: 0 0 40%;
  }
}

@media screen and (max-width: 768px) {
  .data_list .item .number {
    font-size: 16px;
  }
  .box_1440_1 {
    max-width: 100%;
    flex: 0 0 100%;
    .doughnut_box {
      margin-left: 10%;
    }
  }
  .box_1440_2 {
    max-width: 100%;
    flex: 0 0 100%;
    margin-bottom: 20px;
  }
  .box_1440_3 {
    max-width: 100%;
    flex: 0 0 100%;
    .box {
      overflow: hidden;
    }
  }
  .report_form {
    padding: 20px;
    .header_title {
      font-size: 28px;
      margin-bottom: 20px;
      span {
        &::before,
        &::after {
          width: 77px;
          height: 2px;
          background-size: 100%;
        }
        &::before {
          margin-right: 20px;
        }
        &::after {
          margin-left: 20px;
        }
      }
    }
  }
  .package_box ul {
    padding-left: 0;
  }
}

.avatar_box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  line-height: 2;
  color: #fff;
  .l {
    display: flex;
    align-items: center;
    > img {
      margin-right: 16px;
      width: 86px;
      height: 86px;
    }
    .t1 {
      font-size: 18px;
    }
    .t2 {
      background: #2e5bf6;
      border-radius: 4px;
      line-height: 23px;
      display: inline-block;
      padding: 0 7px;
    }
  }
  .r {
    display: flex;
    align-items: center;
    text-align: right;
    .item {
      margin-left: 158px;
      .t1 {
        color: #9ea9c3;
        font-size: 16px;
      }
      .t2 {
        font-size: 22px;
      }
    }
  }
  &.mobile {
    .r {
      display: none;
    }
  }
}

.select_item {
  background: #1d3564;
  height: 56px;
  display: flex;
  align-items: center;
  font-size: 18px;
  color: #ffffff;
  padding: 10px 15px;
  cursor: pointer;
  &.active,
  &:hover {
    background-color: #194dff;
  }
  img {
    width: 35px;
    height: 35px;
    border-radius: 50%;
    margin-right: 10px;
  }
}

.count_box {
  display: grid;
  gap: 12px;
  grid-template-columns: repeat(6, 1fr);
  .item {
    height: 112px;
    display: flex;
    align-items: center;
    line-height: 1.5;
    img {
      margin-right: 22px;
      width: 56px;
      height: 56px;
    }
    .t1 {
      font-size: 18px;
    }
    .t2 {
      font-size: 22px;
      font-weight: bold;
    }
  }
  &.mobile {
    grid-template-columns: repeat(2, 1fr);
    .item {
      height: 75px;
      img {
        margin-right: 15px;
        width: 37px;
        height: 37px;
      }
      .t1 {
        font-size: 12px;
      }
      .t2 {
        font-size: 15px;
      }
    }
  }
}

.el-pagination {
  &.mobile {
    width: 100%;
    overflow: auto;
  }
}
</style>
